import Reveal from "./Reveal";
import Eyebrow from "./Eyebrow";

const POINTS = [
    {
        n: 1,
        title: "Gerçek içerik",
        desc: "Poz verilmiş görseller değil; işletmenizin kendi atmosferi.",
    },
    {
        n: 2,
        title: "Düzenli üretim",
        desc: "Her ay planlı çekim ve yayın takvimi.",
    },
    {
        n: 3,
        title: "Tek ekip, tek süreç",
        desc: "Çekimden yayına aynı ekip, tek elden yönetim.",
    },
];

export default function Why() {
    return (
        <section data-testid="why-section" className="py-24 md:py-32">
            <div className="mx-auto w-full max-w-[1240px] px-6 md:px-10">
                <Reveal>
                    <Eyebrow>Neden Bi Kadraj</Eyebrow>
                    <h2 className="mt-5 font-display text-4xl leading-tight text-cream sm:text-5xl lg:text-6xl">
                        Gösterişten çok düzen.
                    </h2>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-fog md:text-lg">
                        Amacımız sosyal medyanızı karmaşık hale getirmek değil.
                        Düzenli, gerçek ve markanıza uygun bir içerik sistemi
                        kurmak.
                    </p>
                </Reveal>

                <div className="mt-16 grid gap-10 md:mt-20 md:grid-cols-3 md:gap-8">
                    {POINTS.map((p, i) => (
                        <Reveal key={p.n} delay={i * 0.1}>
                            <div
                                data-testid={`why-point-${p.n}`}
                                className="border-t border-cream/15 pt-6"
                            >
                                <span className="h-1.5 w-1.5 rounded-full bg-brick" aria-hidden="true" />
                                <h3 className="mt-4 font-display text-2xl text-cream md:text-3xl">
                                    {p.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-fog">
                                    {p.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
